module.exports = __webpack_public_path__ + "img/seguros.0a3d5a22.png";